export default __webpack_public_path__ + "static/media/barbara.d78d7b18.png";